import React from 'react';
import AnimatedPresence from 'pathfinder/modules/shared/AnimatedPresence/AnimatedPresence';
import CommunityIcon from 'pathfinder/modules/MarketingNotifications/assets/community.svg';
import MarketingIcon from 'pathfinder/modules/MarketingNotifications/assets/marketing.svg';
import ResearchIcon from 'pathfinder/modules/MarketingNotifications/assets/research.svg';
import { StyledButton, StyledIconMenuControl, StyledNotificationContent, StyledNotificationFixedContainer, StyledNotificationIcon, StyledNotificationToggle, StyledParagraph, } from './styled';
import { NotificationTypes } from 'pathfinder/modules/NotificationCMS/interfaces/types';
import { getIsDarkTheme } from 'pathfinder/modules/ComparisonsCharactersModule/utils/mw';
var TRANSITION_TIMEOUT = 200;
export var CollapsibleBanner = function (_a) {
    var body = _a.body, cta = _a.cta, url = _a.url, type = _a.type, isMobile = _a.isMobile, isExpanded = _a.isExpanded, onCTAClick = _a.onCTAClick, onArrowClick = _a.onArrowClick;
    var isDarkTheme = getIsDarkTheme();
    return (React.createElement(AnimatedPresence, { timeout: TRANSITION_TIMEOUT, initialStyle: {
            transform: isMobile ? "translateX(100%)" : "translateY(100%)",
            transition: "transform ".concat(isMobile ? 500 : 300, "ms ease-in-out"),
        }, animateStyle: { transform: isMobile ? "translateX(0%)" : "translateY(0%)" }, leaveStyle: { transform: isMobile ? "translateX(100%)" : "translateY(-100%)" } },
        React.createElement(StyledNotificationFixedContainer, { isExpanded: isExpanded, isMobile: isMobile },
            React.createElement(StyledNotificationToggle, { role: "button", tabIndex: 0, isMobile: isMobile, onClick: function () { return onArrowClick && onArrowClick(isExpanded); }, onKeyDown: function (e) {
                    if (e.code === 'Enter') {
                        onArrowClick && onArrowClick(isExpanded);
                    }
                } },
                React.createElement("div", { "aria-expanded": isExpanded },
                    React.createElement(StyledIconMenuControl, null))),
            React.createElement(StyledNotificationContent, { isMobile: isMobile },
                React.createElement(StyledNotificationIcon, { isDark: isDarkTheme },
                    type === NotificationTypes.community && React.createElement(CommunityIcon, null),
                    type === NotificationTypes.marketing && React.createElement(MarketingIcon, null),
                    type === NotificationTypes.research && React.createElement(ResearchIcon, null)),
                React.createElement("div", null,
                    React.createElement(StyledParagraph, null, body),
                    React.createElement(StyledButton, { href: url, target: "_blank", rel: "nofollow noopener noreferrer", text: true, onClick: function () {
                            onCTAClick && onCTAClick();
                        } }, cta))))));
};
